import { datadogLogs } from '@datadog/browser-logs';

const productionHostname = "klix-web.com";
const productionShareHost = "klix-share.com";
const productionShareUrl = 'https://klix-share.com';

const preproductionHostname = "preprod.klix-web.com";
const preproductionShareHost = "preprod.klix-share.com";
const preproductionShareUrl = 'https://preprod.klix-share.com';

const stagingHostname = "staging.klix-web.com";
const stagingShareHost = 'staging.klix-share.com';
const stagingShareUrl = 'https://staging.klix-share.com';

const demoHostname = "demo.klix-web.com";
const demoShareHost = 'demo.klix-share.com';
const demoShareUrl = 'https://demo.klix-share.com';

var isDev = (location.host == "localhost:8000" || (location.host.split(".").length == 4));
var isStaging = location.host == stagingHostname || location.host == stagingShareHost;
var isPreprod = location.host == preproductionHostname || location.host == preproductionShareHost;
var isProduction = location.host == productionHostname || location.host == productionShareHost;
var isDemo = location.host == demoHostname || location.host == demoShareHost;

var root = ((isDev || isStaging) && "https://preprod.klix-web.com/api") || `https://${location.host}/api`;
// var root = ((isDev || isStaging) && "http://localhost:8080/https://staging.klix-web.com/api") ||` https://${location.host}/api`; // cd node_modules/cors-anywhere -> node server.js

const shareUrls = {
  dev: stagingShareUrl,
  staging: stagingShareUrl,
  preprod: preproductionShareUrl,
  production: productionShareUrl,
  demo: demoShareUrl,
  unknown: productionShareUrl
};
const env = (isDev && "dev") || (isStaging && "staging") || (isPreprod && "preprod") || (isProduction && "production") || (isDemo && "demo") || "unknown";
var API = {
  root: root,
  env: env,
  shareUrl: shareUrls[env],
};

const MAX_LOGS_PER_MINUTE = 30;
let logsCounter = 0;

const resetLogsCounter = () => logsCounter = 0;

if (!window.resetLogCounterInterval)
  window.resetLogCounterInterval  = setInterval(resetLogsCounter, 60 * 1000);

window.onbeforeunload = () => {
  clearInterval(window.resetLogCounterInterval);
  delete window.resetLogCounterInterval;
};

if (isProduction) {
  datadogLogs.onReady(() => {
    datadogLogs.init({
      clientToken: 'pub540b66eafaeededf24555be4d733f4fe',
      site: 'datadoghq.eu',
      env: API.env,
      version: window.frontendVersion,
      forwardErrorsToLogs: true,
      sampleRate: 100,
      beforeSend: (log) => {
        const clarityXHRErrorRegex = /XHR error.*clarity.*/g;

        if (clarityXHRErrorRegex.test(log.message)) {
          return false;
        }

        if (logsCounter >= MAX_LOGS_PER_MINUTE)
          return false;

        logsCounter++;
      }
    });
  });
}

export default API;
